"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const explorer_1 = require("../../../../explorer");
class BitcoinLikeExplorer {
    constructor({ cryptoCurrency, forcedExplorerURI, }) {
        this.baseUrl =
            forcedExplorerURI != null ? forcedExplorerURI : (0, explorer_1.blockchainBaseURL)(cryptoCurrency);
    }
    broadcast(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/tx/send`;
            const res = yield (0, network_1.default)({
                method: "POST",
                url,
                data: { tx },
            });
            return res;
        });
    }
    getTxHex(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO add a test for failure (at the sync level)
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.baseUrl}/tx/${txId}/hex`,
            });
            return data.hex;
        });
    }
    getCurrentBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}/block/current`;
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url,
            });
            return data ? { height: data.height, hash: data.hash, time: data.time } : null;
        });
    }
    getBlockByHeight(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.baseUrl}/block/${height}`,
            });
            return data[0] ? { height: data[0].height, hash: data[0].hash, time: data[0].time } : null;
        });
    }
    getFees() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO add a test for failure (at the sync level)
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.baseUrl}/fees`,
            });
            return data;
        });
    }
    getRelayFee() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.baseUrl}/network`,
            });
            return parseFloat(data["relay_fee"]);
        });
    }
    getPendings(address, nbMax = 1000) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                batch_size: nbMax,
            };
            const pendingsTxs = yield this.fetchPendingTxs(address, params);
            pendingsTxs.forEach(tx => this.hydrateTx(address, tx));
            return pendingsTxs;
        });
    }
    fetchTxs(address, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.baseUrl}/address/${address.address}/txs`,
                params,
            });
            return data.data;
        });
    }
    fetchPendingTxs(address, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.baseUrl}/address/${address.address}/txs/pending`,
                params,
            });
            return data;
        });
    }
    hydrateTx(address, tx) {
        // no need to keep those as they change
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        delete tx.confirmations;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete tx.hash;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete tx.lock_time;
        // eslint-disable-next-line no-param-reassign
        tx.account = address.account;
        // eslint-disable-next-line no-param-reassign
        tx.index = address.index;
        // eslint-disable-next-line no-param-reassign
        tx.address = address.address;
        tx.inputs.forEach(input => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete input.txinwitness;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete input.script_signature;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete input.input_index;
        });
        tx.outputs.forEach(output => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete output.script_hex;
            // eslint-disable-next-line no-param-reassign
            output.output_hash = tx.id;
            // eslint-disable-next-line no-param-reassign
            output.block_height = tx.block ? tx.block.height : null;
            // Definition of replaceable, per the standard: https://github.com/bitcoin/bips/blob/61ccc84930051e5b4a99926510d0db4a8475a4e6/bip-0125.mediawiki#summary
            output.rbf = tx.inputs[0] ? tx.inputs[0].sequence < 0xffffffff : false;
        });
    }
    getTxsSinceBlockheight(batchSize, address, startingBlockheight, isPending) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                batch_size: batchSize,
            };
            if (!isPending) {
                params.from_height = startingBlockheight;
                params.order = "ascending";
            }
            const txs = isPending
                ? yield this.fetchPendingTxs(address, params)
                : yield this.fetchTxs(address, params);
            const hydratedTxs = [];
            // faster than mapping
            txs.forEach(tx => {
                this.hydrateTx(address, tx);
                hydratedTxs.push(tx);
            });
            return hydratedTxs;
        });
    }
}
exports.default = BitcoinLikeExplorer;
//# sourceMappingURL=index.js.map